// extracted by mini-css-extract-plugin
module.exports = {"navLink":"MainLayout_navLink__3ZGI9","logo":"MainLayout_logo__TKMn7","iconWallet":"MainLayout_iconWallet__3jKrh","content":"MainLayout_content__3eJ-k"};